import { NgModule } from '@angular/core';
// import ngx-translate and the http loader
// https://github.com/ngx-translate/core
// 
// Esse resolveu o translate: -> https://medium.com/@lopesgon/translate-angular-4-with-ngx-translate-and-multiple-modules-7d9f0252f139
// https://stackblitz.com/github/ngx-translate/example?file=src%2Fapp%2Fapp.component.ts
import { TranslateModule } from '@ngx-translate/core';

// https://github.com/KingMario/packages/tree/master/projects/ngx-upper-case-directive
//import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
// https://github.com/KingMario/packages/tree/master/projects/ngx-lower-case-directive
//import { NgxLowerCaseDirectiveModule } from 'ngx-lower-case-directive';
// https://github.com/KingMario/packages/tree/master/projects/ngx-trim-directive
//import { NgxTrimDirectiveModule } from 'ngx-trim-directive';

import { TagInputModule } from 'ngx-chips';
// https://github.com/ng-select/ng-select
import { NgSelectModule } from '@ng-select/ng-select';

import { LaddaModule } from 'angular2-ladda';



import { QuillModule } from 'src/vendor/libs/quill/quill.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { BlockUIModule } from 'ng-block-ui';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
import { NgxLowerCaseDirectiveModule } from 'ngx-lower-case-directive';
import { NumericDirective } from './directives/numeric-directive';
import { DisableControlDirective } from './directives/disable-control-directive ';
import { DateMaskDirective } from './directives/date-mask-directive';
import { TimeMaskDirective } from './directives/time-mask-directive';
import { ProgressPopupComponent } from './others-component/progress-popup/progress-popup.component';
import { AuditViewComponent } from './audit/audit-view/audit-view.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LocalacessoComponent } from './others-component/localacesso-component/localacesso.component';
import { EstoqueComponent } from './others-component/estoque-component/estoque.component';
import { OnlyNumberDirective } from './directives/only-number-directive';
import { EmpresaSetorComponent } from './others-component/empresa-setor-component/empresa-setor.component';
import { EmailPopupComponent } from './others-component/email-popup/email-popup.component';
import { LiberacaoManualPopupComponent } from './others-component/liberacaomanual-popup/liberacaomanual-popup.component';
import { AutorizacaoPopupComponent } from './others-component/autorizacao-popup/autorizacao-popup.component';

import { NgxImageGalleryModule } from 'ngx-image-gallery';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BiometriaPopupComponent } from './others-component/biometria-popup/biometria-popup.component';
import { TipoBiometriaPopupComponent } from './others-component/tipo-biometria-popup/tipo-biometria-popup.component';
import { TipoCartaoPopupComponent } from './others-component/tipo-cartao-popup/tipo-cartao-popup.component';
import { CartaoPopupComponent } from './others-component/cartao-popup/cartao-popup.component';
import { QRCodeModule } from 'angularx-qrcode';
import { TrackCapsDirective } from './directives/TrackCapsDirective';
import { TipoServicoComponent } from './others-component/tipo-servico-component/tipo-servico.component';
import { FornecedorComponent } from './others-component/fornecedor-component/fornecedor.component';
import { UsuarioViewComponent } from './others-component/usuario-view-component/usuario-view-component';
import { TimeagoModule } from 'ngx-timeago';
import { UploadPopupComponent } from './others-component/upload-popup/upload-popup.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { WebcamModule } from 'ngx-webcam';
import { DropzoneModule } from 'ngx-dropzone-wrapper';

// https://github.com/sujono91/reactive-template-driven/blob/master/src/app/shared/shared.module.ts
const SHARED_MODULE = [
  TranslateModule,
  NgbModule,
  CommonModule,
  HttpClientModule,
  NgbModule,
  InfiniteScrollModule,
  FormsModule,
  ReactiveFormsModule,
  // https://github.com/ng-select/ng-select
  NgSelectModule,
  TagInputModule,
  LaddaModule,
  NgxImageGalleryModule,
  SweetAlert2Module,
  BlockUIModule,
  QRCodeModule,
  TimeagoModule,
  ImageCropperModule,
  WebcamModule,
  DropzoneModule 


];

@NgModule({
  declarations: [
    NumericDirective,
    OnlyNumberDirective,
    DisableControlDirective,
    DateMaskDirective,
    TimeMaskDirective,
    ProgressPopupComponent,
    AuditViewComponent, // Add modal component to "declarations"
    LocalacessoComponent, // Add modal component to "declarations"
    EstoqueComponent, // Add modal component to "declarations"
    EmpresaSetorComponent, // Add modal component to "declarations"
    EmailPopupComponent, // Add modal component to "declarations"
    LiberacaoManualPopupComponent, // Add modal component to "declarations"
    AutorizacaoPopupComponent,
    BiometriaPopupComponent,
    TipoBiometriaPopupComponent,
    TipoCartaoPopupComponent,
    CartaoPopupComponent,
    TrackCapsDirective,
    TipoServicoComponent, // Add modal component to "declarations"
    FornecedorComponent, // Add modal component to "declarations"
    UsuarioViewComponent, // Add modal component to "declarations"
    UploadPopupComponent

  ],
  exports: [
    ...SHARED_MODULE,
    //NgxUpperCaseDirectiveModule,
    //NgxLowerCaseDirectiveModule,
    //NgxTrimDirectiveModule,

    QuillModule,
    NgxUpperCaseDirectiveModule,
    NgxLowerCaseDirectiveModule,
    NumericDirective,
    OnlyNumberDirective,
    DisableControlDirective,
    DateMaskDirective,
    TimeMaskDirective,
    TrackCapsDirective,

    ProgressPopupComponent,

    AuditViewComponent, // Add modal component to "declarations"
    LocalacessoComponent, // Add modal component to "declarations"
    EstoqueComponent, // Add modal component to "declarations"
    EmpresaSetorComponent, // Add modal component to "declarations"
    EmailPopupComponent, // Add modal component to "declarations"
    LiberacaoManualPopupComponent, // Add modal component to "declarations"
    AutorizacaoPopupComponent,
    BiometriaPopupComponent,
    TipoBiometriaPopupComponent,
    TipoCartaoPopupComponent,
    CartaoPopupComponent,
    TipoServicoComponent, // Add modal component to "declarations"
    FornecedorComponent, // Add modal component to "declarations"
    UsuarioViewComponent, // Add modal component to "declarations"
    UploadPopupComponent

  ],
  imports: SHARED_MODULE
})

export class SharedModule {
  
 }